import { render, staticRenderFns } from "./admin_seller_orders.vue?vue&type=template&id=71df6160&"
import script from "./admin_seller_orders.vue?vue&type=script&lang=js&"
export * from "./admin_seller_orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports